import { QueryClientProvider } from '@tanstack/react-query';
import { ComponentType } from 'react';

import { queryClient } from '@/utils/query';

const withQueryClientProvider = <P extends object>(WrappedComponent: ComponentType<P>): ComponentType<P> => {
  const WithQueryClientProvider = (props: P) => (
    <QueryClientProvider client={queryClient}>
      <WrappedComponent {...props} />
    </QueryClientProvider>
  );

  return WithQueryClientProvider;
};

export default withQueryClientProvider;
